// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1481":"871a5c8390039fa7","3213":"96abc63c03d2c612","4123":"b98a0accdc3b48de","6642":"23fb9c67ef3bbd50"}[chunkId] + ".js";
};